// Phase 31 Plan 31-01 — RUNE-10 banded token reward lookup (client-side mirror).
//
// Source of truth: apps/backend/src/match/economy/defaults.ts L103-110
// (TOKEN_REWARD_BANDS) and apps/backend/src/match/economy/tokens.ts:lookupBand.
// Bands per amendment §2.4:
//   1-4   → 1 token
//   5-8   → 2 tokens
//   9-13  → 3 tokens
//   14-20 → 4 tokens
//   21-30 → 5 tokens
//   31+   → 7 tokens  (deliberate jump — there is NO band yielding 6)
//
// The web client mirrors these for ScorePill display ONLY. Server is
// authoritative on submitted-turn token rewards (DEC-021); this helper lets
// the ScorePill preview the lookup before the TURN_APPLIED frame lands.
//
// Pure function. No I/O. No allocation. Branchless O(bands).

export function tokenBandFor(wordScore: number): number {
  if (wordScore <= 0) return 0
  if (wordScore <= 4) return 1
  if (wordScore <= 8) return 2
  if (wordScore <= 13) return 3
  if (wordScore <= 20) return 4
  if (wordScore <= 30) return 5
  return 7
}
